var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"menu--dropdown"},[_vm._l((_vm.menuCategories),function(item){return [(item.subMenu)?_c('menu-mega',{attrs:{"menu-data":item}}):_c('li',{key:item.text},[_c('nuxt-link',{attrs:{"to":item.url}},[_vm._v("\n                    "+_vm._s(item.text)+"\n                ")])],1)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }